import Map from '../app/map';

export default {
    init() {
        // JavaScript to be fired on the home page
    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
        new Map('#map', {
            address: $('section.map').find('.address').text(),
            title: 'Aerodyne',
            icon: window.cc_data.template_url + '/dist/images/map-icon.svg',
            zoom: 16,
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/Contact.js